import { render } from "./cyclingjersey.vue?vue&type=template&id=5bd633fc"
import script from "./cyclingjersey.vue?vue&type=script&lang=js"
export * from "./cyclingjersey.vue?vue&type=script&lang=js"

import "./cyclingjersey.vue?vue&type=style&index=0&id=5bd633fc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__